<template>
  <ion-page id="landing-page">
    <ion-content>

    <TopLine :style="styleTopline" title="Web Page" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

    <div :style="styleMiddle">
      <div id="display-html" class="iframe-container">
        <!-- <iframe id="myIframe" :srcdoc="html" frameborder="0" ></iframe> -->
        <iframe id="myIframe" :src="url" frameborder="0" ></iframe>
    </div>
    </div>
    <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />

 </ion-content>
 </ion-page>
 
</template>

<script setup>

  import { IonLabel,IonCol, IonRow, IonGrid, IonButton, IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import TopLine from '@/components/TopLine.vue'
  import { parseWordsSaid } from '@/composables/wordlistSupport.js'

  import { ref, onMounted, watch } from 'vue'
  import { useConnectionStore } from '../stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import ToolBar from '@/components/ToolBar.vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    isScreenPortraitOrientation } from '@/composables/screenSize'

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const url = ref("https://www.chessvis.com/verbal2/website")

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const isDark = ref(connectionStore.getDarkmode != "light")

  const wordlistLanding = "command done scroll up down mute listen"

  const wordlist = ref(wordlistLanding)
  emit("word-list",wordlistLanding)

  const wordlistTrigger = ref(0)

  const explainTitle = ref("")
  const explainMessage = ref("")

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const topLineString = ref("")

  const TOOLBAR_GOOGLE = 0
  const TOOLBAR_APPLE = 1
  const toolbarElements = ref([
      { index : TOOLBAR_GOOGLE, label : "Android Store" ,disabled : false},
      { index : TOOLBAR_APPLE, label : "IOS Store" ,disabled : false},
  ])

  const toolbarTrigger = ref(0)

  var scrollTop = 0

  var trackingScrollTop = 0

  doStartupCheck(false,afterStartupCallbackRoutine)

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  onMounted(() => {

  })


  function toplineClick(whatClicked) {
    console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  // this is only on page with buttons
  function toolbarClick(arrayIndex) {
      
  }

  function afterStartupCallbackRoutine(stuffChanged) {
  }

  function scrollIframe(divId,iFrameId,direction) {
    const divElement = document.getElementById(divId)
    const iFrameElement = document.getElementById(iFrameId)

    if (divElement == null) {
      console.log("**** no div element to scroll",divId)
      return
    }
    if (iFrameElement == null) {
      console.log("**** no iframe element to scroll",iFrameId)
      return
    }

    const divHeight = divElement.offsetHeight;
    //var scrollTop = divElement.scrollTop

    console.log("scrolltop",trackingScrollTop)
    switch (direction) {
      case "down" :
        trackingScrollTop += divHeight
        break
      case "up" :
        trackingScrollTop -= divHeight
        if (trackingScrollTop < 0)
          trackingScrollTop = 0
        break
      case "top" :
        trackingScrollTop = 0
        break
    }
    try {
    iFrameElement.contentWindow.scroll(0,trackingScrollTop)
    } catch (e) {
      console.log("scroll error",e)
    }
    //divElement.scroll(0,scrollTop)
  }


  function processWords(text) {
    //console.log("text in engine Menu ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "scroll" :
        scrollIframe("display-html","myIframe",returnArray[0])
        break
      case "done" :
        emit("where-next","/")
        break  
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "done") {
            return ["done",""]
        }
        if (currentWord == "scroll") {
          if (nextWord == "up") {
              return ["scroll", "up"]
          }
          if (nextWord == "down") {
              return ["scroll", "down"]
          }
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

</script>

<style scoped>

.iframe-container {
    position: relative;
    width: 100%;
    height : 100%;
    padding-top: 56.25%; /* For a 16:9 aspect ratio (9 / 16 = 0.5625) */
    overflow: hidden;
}

.iframe-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>
